import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { authHeaders,getSessionToken } from "../utils/session";

const AddLogoPage = () => {
  const [image, setImage] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [imageError, setImageError] = useState("");
  const [pageError, setPageError] = useState("");
  const [logoDeviceError, setLogoDeviceError] = useState("");
  const [logoDevice, setLogoDevice] = useState('mobile');

  const [token, setToken] = useState(getSessionToken());

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log(image, "form");
    let hasError = false;

    if (!image) {
      setImageError("Please select the image");
      hasError = true;
    } else {
      setImageError("");
    }
    if (!logoDevice) {
      setLogoDeviceError("please select");
      hasError = true;
    } else setLogoDeviceError("");

    const form = new FormData();
    form.append("logo", image);
    form.append('logo_for',logoDevice)
    if (!hasError) {
      await axios
        .post(`${API_BASE_URL}/logo`, form, {
          headers: {
            ...authHeaders(),
          },
        })
        .then((response) => {
          // console.log(response.data.status);
          if (response.data.status === 200) {
            toast.success("Logo added successfully");
            navigate("/cms/managelogo");
          }
        })
        .catch((error) => {
          setPageError(error.response.data.result);
        });
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  


    if (name === "logoDevice") {
      setLogoDevice(value);
    } else {
      setImage(event.target.files[0]);
    }


  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    if (!selectedImage) {
      setImagePreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(selectedImage);
    setImagePreview(objectUrl);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Add Logo </h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">CMS</a>
                      </li>
                      <li className="breadcrumb-item ">
                        <Link to={"/cms/managelogo"}>Manage Logo</Link>
                      </li>
                      <li className="breadcrumb-item active">Add Logo </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-4">Add Logo </h4>
                      <form
                        onSubmit={handleSubmit}
                        enctype="multipart/form-data"
                      >
                        <div data-repeater-list="outer-group" className="outer">
                          <div data-repeater-item className="outer">
                            <div className="inner-repeater mb-4">
                              <div
                                data-repeater-list="inner-group"
                                className="inner form-group mb-0 row"
                              >
                                <label className="col-form-label col-lg-2">
                                  Image
                                </label>
                                <div
                                  data-repeater-item
                                  className="inner col-lg-10 ms-md-auto"
                                >
                                  <div className="mb-3 row align-items-center">
                                    <div className="col-md-12">
                                      <div className="mt-4 mt-md-0">
                                        <input
                                          className={
                                            imageError
                                              ? "form-control is-invalid"
                                              : "form-control "
                                          }
                                          name="image"
                                          type="file"
                                          accept="image/*"
                                          onChange={(e) => {
                                            handleImageChange(e);
                                            handleInputChange(e);
                                          }}
                                        />
                                        {imageError && (
                                          <div className="text-danger">
                                            {imageError}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="mt-4 mt-20">
                                        <div>
                                          {imagePreview && (
                                            <img
                                              src={imagePreview}
                                              alt="Preview"
                                              width="200"
                                              height="200"
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group row mb-4">
                              <label
                                for="taskname"
                                className="col-form-label col-lg-2"
                              >
                                Logo For
                              </label>
                              <div className="col-lg-10">
                                <select
                                  className={
                                    logoDeviceError
                                      ? " form-select is-invalid"
                                      : "form-control "
                                  }
                                  styles="max-width: 90px;"
                                  name="logoDevice"
                                  onChange={handleInputChange}
                                  defaultValue={'mobile'}
                                >
                                  {/* <option value={0}>None of options</option> */}
                                  <option value={'mobile'}>Mobile</option>
                                  <option value={'web'}>Desktop</option>
                                </select>
                                {logoDeviceError && (
                                  <div className="text-danger">
                                    {logoDeviceError}
                                  </div>
                                )}
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>

                        <div className="row justify-content-end">
                          <div className="col-lg-10">
                            {pageError && (
                              <div className="alert alert-danger" role="alert">
                                {pageError}
                              </div>
                            )}
                            <button type="submit" className="btn btn-primary">
                              Add Logo
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLogoPage;
